<template>

  <div>

    <DrawerPartners :items="items" v-bind.sync="filters" class=""
                    @filter-update="setNewFilters"></DrawerPartners>


    <!--    <v-progress-linear :active="loading" indeterminate top height="8"></v-progress-linear>-->

    <v-layout>


      <v-flex shrink>

        <v-list dense shaped
                class="overflow-y-auto pt-3 main-height"
                color="transparent"
                width="320">

          <v-list-item class="mb-2">
            <v-text-field
              prepend-icon="search"
              @input="searchUpdate"
              v-model="filters.search"
              label="Search Partner List"
              :ripple="false"
              hide-details
              clearable
              class="mt-0"
            ></v-text-field>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item active-class="primary white--text"
                       :disabled="$route.params.id === item.id"
                       :to="`/partners/${item.id}`"
                       :ripple="false"
                       v-for="(item, index) in filteredItems"
                       :key="index">

            <v-list-item-icon>
              <!--                  <v-list-item-icon class="hidden-md-and-down">-->
              <!--                <v-icon>mdi-information</v-icon>-->
              <v-avatar color="accent" size="26">
                <span class="white--text">{{item.properties.Name.charAt(0)}}</span>
              </v-avatar>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{item.properties.Name}}
              </v-list-item-title>
            </v-list-item-content>

          </v-list-item>


        </v-list>

      </v-flex>

      <v-flex>

        <h3 class="headline mt-3 ml-3">Broadband Partners</h3>

        <transition name="slide">
          <router-view :items="filteredItems"></router-view>
        </transition>

      </v-flex>

    </v-layout>

  </div>

</template>

<script>
import DrawerPartners from '../components/Drawer.Partners';
import orderBy from 'lodash/orderBy';

export default {

  name: 'Partners',

  components: { DrawerPartners, },

  data() {
    return {
      loading: false,
      items: [],
      filters: {
        search: '',
        video: false,
        category: 'all',
        type: 'all',
      },
    };
  },

  async created() {

    this.loading = true;

    this.items = await this.loadData();

    this.loading = false;

    if (!this.$route.params.id) {
      this.loadFirstItem();
    }

  },

  methods: {

    loadFirstItem() {
      this.$router.push({
        name: 'partners-detail',
        params: {
          id: this.filteredItems[0].id,
        }
      });
    },

    searchUpdate() {
      // this.$emit('filter-update', filters);
    },

    async loadData() {
      this.loading = true;
      const response = await this.$helpers.requests.getPartners();
      this.loading = false;
      return response;
    },

    setNewFilters(value) {
      this.filters = value;
    },

  },

  watch: {

    filteredItems(items) {
      if (!items.find(i => i.id === this.id)) {
        this.loadFirstItem();
      }
    },

  },

  computed: {

    id() {
      return Number(this.$route.params.id);
    },

    filteredItems() {
      let filtered = [];

      if (this.items.length) {

        filtered = orderBy(this.items, ['properties.Name'], ['asc']);

        if (this.filters.search) {
          const search = this.filters.search.toLowerCase();
          filtered = filtered.filter(i => {
            const nameMatch = i.properties.Name.toLowerCase().includes(search);
            const descMatch = i.properties.Descriptio.toLowerCase().includes(search);
            return nameMatch || descMatch;
          });
        }

        if (this.filters.video) {
          filtered = filtered.filter(i => {
            const video = i.properties.Video.trim();
            console.log(`Video: '${video}'`);
            return video;
          });
        }

        if (this.filters.category && this.filters.category !== 'all') {
          filtered = filtered.filter(i => i.properties.Category === this.filters.category);
        }

        if (this.filters.type && this.filters.type !== 'all') {
          filtered = filtered.filter(i => i.properties.Type === this.filters.type);
        }

      }
      return filtered;
    },
  },

};
</script>
